import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatList.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatList.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/ChatList.vue?vue&type=script&lang=js
// module id = Sy64
// module chunks = 1